import {useSelector} from "react-redux";

export default function(property, defaultValue=[]){
    return useSelector(({api})=>api[property]||defaultValue);
}
